import {ICONS} from "../../../icons/icons"

export const PORTFOLIO_SUMMARY_CONFIG = {
    name            : 'Summary',
    menuName        : 'Summary',
    icon            : ICONS.PORTFOLIO,
    // iconLight       : ICONS.PORTFOLIO,
    image           : 'portfolio',
    iconSvg         : 'isvg-view-summary',
    url             : 'summary',
    stringId        : 'summary',
    description     : 'Portfolio projects table view.'
}
